import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getProductByCode(Redis, code, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/product/getByCode?code=${code}`,
      reset,
    );
  },
  // Где вызывается: сервер (роут /api/catalogServer/getCatalog).
  // Порядок товаров раздела по продажам. Ответ кешируется в Redis, как
  // остальные серверные api: продажи обновляются раз в сутки, а каталог
  // дёргает этот список на каждый рендер главного раздела.
  async getConversionOrder(Redis, sectionId, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/product/conversion-order?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер (роут /api/client/product/incrementProductViews).
  async incrementProductViews(id) {
    const response = await axios.post(
      `${config.SERVICE_DATABASE_API_URL}/product/incrementViews`,
      { id },
    );
    return response?.data ?? { ok: false, id };
  },
  // Где вызывается: сервер.
  async getManagerComments(ids) {
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/product/getManagerComments?ids=${ids}`,
    );
    return data;
  },
  // Где вызывается: сервер.
  async getPropNames(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/product/getPropNames`,
      reset,
    );
  },
  // Где вызывается: клиент.
  async getBuyWithThis(ids) {
    const { data } = await axios.get(
      `${config.API_URL}/product/getBuyWithThis?ids=${ids.join(",")}`,
    );
    return data;
  },
  // Где вызывается: сервер.
  async getReviewsAndQuestionsById(Redis, id, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/product/getReviewsAndQuestionsById?id=${id}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getInstallTimes(Redis, mark, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/product/install-times?mark=${encodeURIComponent(mark)}`,
      reset,
    );
  },
  // Где вызывается: сервер.
  async getMinPrices(Redis, sectionId, mark, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/product/min-prices?sectionId=${encodeURIComponent(sectionId)}&mark=${encodeURIComponent(mark)}`,
      reset,
    );
  },
});
